import { forwardRef, useEffect, useState } from "react";
import { DoorOpen, DoorClosed, Settings, LogOut } from "lucide-react";
import Auth from "../../services/AuthService";
import axiosInstance from "../../axiosConfig";
import { handleError } from "../../services/handleError";

const DropdownLoja = forwardRef(({ isOpen, setIsOpen, abrirModal }, ref) => {
    const [aberto, setAberto] = useState(false);

    useEffect(() => {
        buscarStatusLoja();
    }, []);

    const buscarStatusLoja = async () => {
        try {
            const response = await axiosInstance.get('Configs/status');
            setAberto(response.data);
        } catch (error) {
            handleError(error, "Erro ao buscar status estabelecimento.");
        }
    };

    const toggleStatus = async () => {
        try {
            const res = await axiosInstance.put("Configs/status", { aberto: !aberto });
            setAberto(res.data);
        } catch (error) {
            handleError(error, "Erro ao alterar status da loja.");
        }
    };

    return (
        <div ref={ref} className="relative">
            <div className="flex items-center cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
                {localStorage.getItem("restaurante_url") !== "null" && (
                    <img
                        src={localStorage.getItem("restaurante_url")}
                        alt="Logo"
                        className="w-12 h-12 rounded-full"
                    />
                )}
                <div className="ml-2 font-semibold">
                    <div className="flex items-center">
                        {localStorage.getItem("restaurante")}
                    </div>
                    <div className={`px-3 rounded-full text-sm text-white text-center ${aberto ? "bg-green-700" : "bg-red-700"}`}>
                        {aberto ? "Aberto" : "Fechado"}
                    </div>
                </div>
            </div>
            {isOpen && (
                <div className="absolute right-0 mt-2 w-60 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
                    <ul className="py-1 text-sm text-gray-700">
                        <li>
                            <button onClick={toggleStatus} className="flex items-center w-full px-4 py-2 text-left hover:bg-gray-100">
                                {aberto ? <DoorClosed size={15} className="mr-2" /> : <DoorOpen size={15} className="mr-2" />}
                                {aberto ? "Fechar Loja" : "Abrir Loja"}
                            </button>
                            <button onClick={abrirModal} className="flex items-center w-full px-4 py-2 text-left hover:bg-gray-100">
                                <Settings className="mr-2" size={15} /> Configurações
                            </button>
                            <button onClick={() => Auth.logout()} className="flex items-center w-full px-4 py-2 text-left hover:bg-gray-100">
                                <LogOut className="mr-2" size={15} /> Sair
                            </button>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
});

export default DropdownLoja;